// extracted by mini-css-extract-plugin
export default {"root":"PlanCardDiscountLabel_root__Htwnz"};